import { styled } from 'linaria/react';
import { theme } from '../Theme';

export const CurtainBackdrop = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  pointer-events: ${props => (props.isOpen ? 'auto' : 'none')};
  transition: opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    visibility 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
`;

export const CurtainContainer = styled('div')`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%)
    translateY(${props => (props.isOpen ? '0' : 'calc(100% + 20px)')})
    scale(${props => (props.isOpen ? '1' : '0.95')});
  width: 100%;
  max-width: 50rem;
  max-height: 80vh;
  background: white;
  border-radius: 8px 8px 0 0;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    box-shadow 0.4s ease-out;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  box-shadow: ${props =>
    props.isOpen
      ? '0 -8px 32px rgba(0, 0, 0, 0.2), 0 -4px 16px rgba(0, 0, 0, 0.1)'
      : '0 -4px 20px rgba(0, 0, 0, 0.15)'};
  overflow: hidden;
  pointer-events: ${props => (props.isOpen ? 'auto' : 'none')};

  /* Mobile iOS specific positioning */
  @supports (padding: max(0px)) {
    padding-bottom: max(env(safe-area-inset-bottom), 0px);
  }

  /* Ensure it's above iOS address bar */
  ${theme.below.md} {
    max-height: calc(100vh - env(safe-area-inset-top, 0px) - 20px);
    /* Keep bottom positioning for proper slide-up animation */
    bottom: 0;
    top: auto;
    height: auto;
    min-height: 200px;
  }
`;

export const CurtainContent = styled('div')`
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  transform: translateY(${props => (props.isOpen ? '0' : '20px')});
  transition: opacity 0.3s ease-out 0.1s, transform 0.3s ease-out 0.1s;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  ${theme.below.md} {
    padding: 12px;
  }
`;

export const CurtainHandle = styled('div')`
  width: 40px;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  margin: 12px auto 0;
  cursor: grab;
  pointer-events: auto;
  z-index: 1002;
  user-select: none;
  touch-action: none;
  transition: background-color 0.2s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:hover {
    background: #c0c0c0;
  }

  &:active {
    background: #b0b0b0;
    cursor: grabbing;
  }

  &:focus {
    outline: 2px solid #004e42;
    outline-offset: 2px;
  }

  /* Make the handle area larger for easier touch interaction */
  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: -8px;
    right: -8px;
    bottom: -8px;
    border-radius: 6px;
  }
`;

export const CloseButton = styled('button')`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  pointer-events: auto;
  z-index: 1002;

  &:hover {
    background: #f5f5f5;
    color: #333;
  }

  &:active {
    background: #e0e0e0;
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid #004e42;
    outline-offset: 2px;
  }
`;

export const HiddenTitle = styled('h2')`
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: 0;
  clip: rect(0, 0, 0, 0);
`;

export const CurtainHeader = styled('div')`
  position: relative;
  flex-shrink: 0;
`;

export const curtainStyles = {
  backdrop: CurtainBackdrop,
  container: CurtainContainer,
  content: CurtainContent,
  handle: CurtainHandle,
  closeButton: CloseButton,
  hiddenTitle: HiddenTitle,
  header: CurtainHeader
};
